let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gu2Nj")).then(() => parcelRequire('h11RW'));